export enum DashboardViewProps {
  HEADING = 'Dashboard',
  EMPTY_ICON_ALT = 'empty state',
  SUB_HEADING = 'Get to know your first products CO\u2082e',
  BUTTON_LABEL = 'Create Product',
  CHART_ONE_HEADING = 'Total Emissions per 1kg of Product',
  CHART_TWO_HEADING = 'Total Emissions for Annual Production of Products',
}
